<template>
  <div>
    <FormulaBanner :title="title" :formulaCode="formulaCode" />
    <div class="index">
      <!-- 表单 -->
      <div>
        <div class="top_nav"><span></span>{{ title }}</div>
        <div class="formBody">
          <!-- 表单 -->
          <MyPatient
            :memberId="memberId"
            :selectValue="selectValue"
            @change="userChange"
          />
          <TemplateFiveList
            :type="'radio'"
            :list-data="listData"
            :selectValue="listSelect"
            @change="listChange"
          ></TemplateFiveList>
          <TemplateFiveList
            :type="'check'"
            :list-data="listDataCheck"
            :selectValue="listSelectCheck"
            @change="listChangeCheck"
          ></TemplateFiveList>
          <TemplateFiveList
            :type="'radio'"
            :list-data="listData2"
            :selectValue="listSelect2"
            @change="listChange2"
          ></TemplateFiveList>
          <TemplateFiveList
            :type="'check'"
            :list-data="listDataCheck2"
            :selectValue="listSelectCheck2"
            @change="listChangeCheck2"
          ></TemplateFiveList>
          <TemplateFiveList
            :type="'radio'"
            :list-data="listData3"
            :selectValue="listSelect3"
            @change="listChange3"
          ></TemplateFiveList>
          <div
            v-if="compute === true"
            style="margin: 16px;display: flex;justify-content: center;"
          >
            <van-button
              class="formula-template-button"
              block
              type="info"
              @click="submit"
              style="width:90px"
              >提交</van-button
            >
          </div>
        </div>
      </div>
      <CalculationResults
        :countText="countValue"
        :countTextList="countTextList"
        v-if="show"
      ></CalculationResults>
      <!-- 后台设置的值 -->
      <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
      <!-- 参考文献 -->
      <FormulaReferences
        :references-data="tableData.references"
      ></FormulaReferences>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        title="应激指数"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import MyPatient from "@/components/MyPatient.vue";
import FormulaBanner from "@/components/FormulaBanner.vue";
import { Toast } from "vant";
import { getAdmins } from "@/utils/adminDate";
import { setById } from "@/service/base";
import {
  getFormula,
  getFormulaHuiXian,
  postFormula,
} from "@/service/BodyMassIndex_api";
import FormulaExplain from "@/components/template1/FormulaExplain";
import FormulaReferences from "@/components/template1/FormulaReferences";
import TemplateFiveList from "@/components/Template5/TemplateFiveList";

import CalculationResults from "@/components/CalculationResults";
export default {
  name: "medicalSearch",
  data() {
    return {
      compute: true,
      countTextList: [],
      show: false,
      countValue: "",
      listSelect: [],
      listSelect2: [],
      listSelect3: [],
      listSelectCheck: [],
      listSelectCheck2: [],
      listData: [
        {
          title: "清醒状态",
          columns: [
            "强烈刺激后无睁眼反应，脸部也无痛苦表情 ",
            "强烈刺激后无睁眼反应，仅面部有痛苦表情 ",
            "强烈刺激后能睁眼",
            "轻痛刺激后无睁眼反应",
            "言语命令能睁眼",
            "自主睁眼",
          ],
          fenzhi: [0, 1, 2, 3, 4, 5], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
        },
      ],
      listData2: [
        {
          title: "镇静状态",
          columns: [
            "危及生命的躁动",
            "躁动，不服从语言性命令 ",
            "躁动，服从语言性指令",
            "镇静 ",
          ],
          fenzhi: [0, 1, 2, 3], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
        },
      ],
      listData3: [
        {
          title: "脸部放松",
          columns: [
            "持久的痛苦表情",
            "严重激怒表情 ",
            "适度激怒表情",
            "放松表情",
          ],
          fenzhi: [0, 1, 2, 3], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
        },
      ],
      listDataCheck: [
        {
          title: "理解能力",
          columns: ["睁眼/闭眼", "张嘴 ", "对视", "点头", "闭眼的同时张嘴"],
        },
      ],
      listDataCheck2: [
        {
          title: "人机顺应性",
          columns: [
            "呼吸机送气期间无气流对抗",
            "呼吸频率<30/min",
            "无呛咳",
            "未应用辅助呼吸机",
          ],
        },
      ],

      formulaCode: "",
      shengao: "",
      yingjizhishu: "",
      title: "",
      memberId: "1111",
      selectValue: "",
      username: "",
      value: "",
      showPopover: false,
      showPicker: false,
      columns: ["", "", "", ""],
      nianling: "",
      xingbie: null,
      tableData: {},
      countText: "",
      patientId: null,
      result: null,
      yingjizhishuzhi: "",
      tizhong: "",
      xueqingnanongdu: "",
      fenzhiList: [],
      fenzhiList2: [],
      fenzhiList3: [],
    };
  },
  components: {
    FormulaBanner,
    MyPatient,
    FormulaExplain,
    FormulaReferences,
    TemplateFiveList,
    CalculationResults,
  },
  async created() {
    await this.test();
    await this.getTableData();
  },

  methods: {
    listChange(result, fenzhi) {
      this.show = false;
      this.listSelect = result; //结果数组
      this.fenzhiList = fenzhi; //分值数组
    },
    listChange2(result, fenzhi) {
      this.show = false;
      this.listSelect2 = result; //结果数组
      this.fenzhiList2 = fenzhi; //分值数组
    },
    listChange3(result, fenzhi) {
      this.show = false;
      this.listSelect3 = result; //结果数组
      this.fenzhiList3 = fenzhi; //分值数组
    },
    listChangeCheck(result) {
      this.listSelectCheck = result;
      this.show = false;
      console.log(this.listSelectCheck);
    },
    listChangeCheck2(result) {
      this.listSelectCheck2 = result;
      this.show = false;
    },
    coumputTetxt() {
      this.show = true;
      let fenshu = 0;
      let fenshu2 = 0;
      let fenshu3 = 0;
      let fenshuAll = 0;
      //   let fenshuCheck = 0;
      for (let i = 0; i < this.fenzhiList.length; i++) {
        fenshu += this.fenzhiList[i];
      }
      for (let i = 0; i < this.fenzhiList2.length; i++) {
        fenshu2 += this.fenzhiList2[i];
      }
      for (let i = 0; i < this.fenzhiList3.length; i++) {
        fenshu3 += this.fenzhiList3[i];
      }
      fenshuAll =
        fenshu +
        fenshu2 +
        fenshu3 +
        this.listSelectCheck[0].value.length +
        this.listSelectCheck2[0].value.length;

      console.log(fenshuAll);

      this.countText = fenshuAll;
      this.result = fenshuAll;
      this.countValue = `${fenshuAll}分 `;
    },
    async test() {
      //像接口头部传用户信息
      let arrays = await getAdmins(
        this.$route.query.memberId,
        this.$route.query.channel
      );
      this.channel = arrays.os;
      this.version = arrays.version;
      this.ip = arrays.ip;
      await setById(arrays);
    },
    async getTableData() {
      const data = {
        channel: this.$router.currentRoute.query.channel,
        code: "EPADNVXH",
      };
      const res = await getFormula(data.channel, data.code);
      if (res.code === 0) {
        this.tableData = res.data;
        this.formulaCode = res.data.code;
        this.title = res.data.chineseName;
      }
      if (
        this.$router.currentRoute.query.location === "YXGS_RECORD_LIST" &&
        this.$router.currentRoute.query.logId
      ) {
        // this.compute = false
        const data = {
          id: this.$router.currentRoute.query.logId,
        };
        const res = await getFormulaHuiXian(data);
        if (res.code === 0) {
          this.listSelect = res.data.content.data.listSelect;
          this.listSelect2 = res.data.content.data.listSelect2;
          this.listSelect3 = res.data.content.data.listSelect3;
          this.listSelectCheck = res.data.content.data.listSelectCheck;
          this.listSelectCheck2 = res.data.content.data.listSelectCheck2;
          if (res.data.patientId)
            this.selectValue = {
              id: res.data.patientId,
              name: res.data.patientName,
            };
          // this.fenzhiList = [res.data.result.value];
          this.result = res.data.result.value;
          this.countText = res.data.result.result;
          this.countValue = res.data.result.value + "分";
          this.show = true;
        }
      }
    },
    async submit() {
      if (
        this.listSelect.length == 0 ||
        this.listSelect2.length == 0 ||
        this.listSelect3.length == 0 ||
        this.listSelectCheck.length == 0 ||
        this.listSelectCheck2.length == 0
      ) {
        Toast.fail("请完善选择");
        return;
      }
      this.coumputTetxt();
      const data = {
        id:
          this.$router.currentRoute.query.location === "YXGS_RECORD_LIST"
            ? this.$router.currentRoute.query.logId
            : null,
        patientId: this.patientId,
        //   columnCode: this.tableData.columnCode,
        columnCode: "0",
        formulaCode: this.tableData.code,
        channel: this.$router.currentRoute.query.channel,
        location: this.$router.currentRoute.query.location,
        content: {
          data: {
            listSelect: this.listSelect,
            listSelect2: this.listSelect2,
            listSelect3: this.listSelect3,
            listSelectCheck: this.listSelectCheck,
            listSelectCheck2: this.listSelectCheck2,
          },
        },
        result: {
          value: this.result,
          result: this.countText,
          DisplayResults: this.countValue,
        },
      };
      const res = await postFormula(data);
      if (res.code === 0) {
        Toast.success("提交成功");
      } else {
        Toast.fail(res.message);
      }
    },
    calculateAge(birthDateString) {
      const today = new Date();
      const birthDate = new Date(birthDateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      // 如果今天的日期还没到生日月份和日期，则年龄减一
      if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    // 开参考文献链接
    openLink(u) {
      if (!u) {
        return;
      }
      //获取系统版本
      let userAI = navigator.userAgent;
      const isAndroid =
        userAI.indexOf("Android") > -1 || userAI.indexOf("Linux") > -1; //Android终端
      const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        // alert('安卓操作系统')
        // 这个是安卓操作系统
        window.open(u);
      }
      if (isIOS) {
        // 这个是ios操作系统
        // alert('ios操作系统')
        window.location.href = u;
      }
    },
    yingjiClick() {
      this.showPicker = true;
    },
    onConfirm(value) {
      this.yingjizhishu = value;
      this.showPicker = false;
    },
    onCancel() {
      this.showPicker = false;
    },
    async onSubmit() {
      this.coumputTetxt();
      const data = {
        id:
          this.$router.currentRoute.query.location === "YXGS_RECORD_LIST"
            ? this.$router.currentRoute.query.logId
            : null,
        patientId: this.patientId,
        columnCode: this.tableData.columnCode,
        formulaCode: this.tableData.code,
        channel: this.$router.currentRoute.query.channel,
        location: this.$router.currentRoute.query.location,
        content: {
          shengao: { value: this.shengao, unit: "cm" },
          tizhong: { value: this.tizhong, unit: "kg" },
          nianling: { value: this.nianling, unit: "岁" },
          xingbie: { value: this.xingbie == 1 ? "男" : "女" },
          // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
        },
        result: {},
      };
      if (this.xingbie == 1) {
        data.result.nanxing = { value: this.result, unit: "kcal" };
      } else {
        data.result.nvxing = { value: this.result, unit: "kcal" };
      }
      const res = await postFormula(data);
      if (res.code === 0) {
        Toast.success("提交成功");
      } else {
        Toast.fail(res.message);
      }
    },
    userChange(data) {
      if (data.birthday && data.birthday !== "") {
        this.nianling = this.calculateAge(data.birthday);
      } else {
        this.nianling = "";
      }
      this.xingbie = data.sex;
      this.patientId = data.id;
      this.selectValue = data;
    },
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f6f6f6;
  padding: 10px 15px;
  min-height: 100vh;
  .StandardDescription {
    margin-top: 10px;
    .top_nav {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom: 10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .StandardDeatil {
      width: 100%;
      padding: 15px 10px;
      //   height: 50px;
      background-color: #fff;
      box-sizing: border-box;
    }
  }
  .top_nav {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: start;
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 5px;
      height: 15px;
      background: #259beb;
      margin-right: 5px;
    }
  }
  .formBody {
    background-color: #fff;
    padding-bottom: 10px;
    .CalculationResultsBox {
      padding: 0 8px;
      .CalculationResults {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
      }
      .CalculationDetail {
        font-size: 15px;
        color: #333333;
        // font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom: 10px;
        background-color: #f6f6f6;
        // height: 16px;
        span {
          display: inline-block;
          width: 3px;
          height: 24px;
          background: #fe9712;
          margin-right: 5px;
        }
      }
    }
  }
  .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 10px;
    box-sizing: border-box;
    .titlesName {
      font-size: 16px;
      i {
        color: red;
      }
    }
    .information {
      font-size: 16px;
      margin-right: 4px;
      .PleaseSelect {
        color: #b9b9b9;
      }
      .vanCell {
        width: 50px;
        padding: 0;
        height: 100%;
      }
    }
    .vBotton {
      width: 60px;
    }
    .unit {
      height: 50px;
      //   line-height: 50px;
      display: flex;
      align-items: center;
      font-size: 16px;
      width: 20px;
    }
    .vanIcon {
      font-size: 13px;
      color: #a8a8a8;
      font-weight: 650;
    }
  }
}
::v-deep .van-cell {
  padding: 0px 0px;
}
::v-deep .van-field__control {
  height: 50px;
  font-size: 16px;
}
::v-deep .van-field__error-message {
  position: absolute;
  top: 30px;
  left: 10px;
}
.StandardDeatil2 {
  width: 100%;
  padding: 15px 10px;
  padding-bottom: 1px;
  //   height: 50px;
  background-color: #fff;
  box-sizing: border-box;
  .references {
    margin-bottom: 15px;
  }
}
::v-deep p {
  padding: 0;
  margin: 0;
}
.Abutton {
}
.box-div-dis-zi {
  margin-right: 15px;
}
</style>
